import { render } from "./금연클리닉.vue?vue&type=template&id=18c19445"
import script from "./금연클리닉.vue?vue&type=script&lang=js"
export * from "./금연클리닉.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__